'use strict';

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.is-array');

require('core-js/modules/es6.array.for-each');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.map');

require('core-js/modules/es6.promise');

require('./app/main');

require('./app/modules/min-max-setting');

require('./app/watchdog');

require('./app/user');

var _tableTemplates = require('./app/table-templates');

var _tableTemplates2 = _interopRequireDefault(_tableTemplates);

require('./app/table-controls');

var _initializers = require('./app/initializers');

var _initializers2 = _interopRequireDefault(_initializers);

var _store = require('./app/store');

var _store2 = _interopRequireDefault(_store);

var _store3 = require('linksoft/core/store');

var _store4 = _interopRequireDefault(_store3);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _localize = require('linksoft/core/localize');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _settingsFix = require('./app/settingsFix');

var _settingsFix2 = _interopRequireDefault(_settingsFix);

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is entry point for building single output 'main.js' (except vendor libs defined in 'Gulp/vendors.js')

// polyfills
var log = (0, _debug2.default)('app:startup');

// register all required initializers
_initialize2.default.registerAll(_initializers2.default);

_initialize2.default.register(_linksoftReact2.default.finalizer, true);

// trigger first initialization.
(0, _jquery2.default)(function () {
    // create app state store
    _store4.default.set((0, _store2.default)());

    _settingsFix2.default.backupSettings();
    _linksoftAlbatros.settings.initFromHiddenField('settings');
    _settingsFix2.default.restoreSettingsElement();

    (0, _tableTemplates2.default)();

    (0, _localize.loadLocale)().then(function () {
        _initialize2.default.trigger();
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app.js
// module id = 0
// module chunks = 1